export default function Footer() {
  const year = new Date().getFullYear();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="bg-brand-bg2 border-t border-brand-line py-12" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-3">
              <img
                src="/logo-24vox.jpg"
                alt="24Vox"
                className="h-14 w-14 rounded-lg object-contain bg-[#0a0a14] p-1"
              />
              <p className="font-heading text-2xl font-bold text-brand-ink">
                24<span className="text-brand-terra">Vox</span>
              </p>
            </div>
            <p className="text-sm italic text-brand-inkSoft mb-3">la tua voce, sempre...</p>
            <p className="text-sm text-brand-inkSoft max-w-sm leading-relaxed">
              L'assistente vocale che risponde quando tu non puoi. In italiano. Per imprenditori italiani.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm uppercase tracking-wider text-brand-ink mb-4">Sito</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/come-funziona" className="text-brand-inkSoft hover:text-brand-ink transition-colors" data-testid="footer-link-how">Come funziona</a></li>
              <li><button onClick={() => scrollTo("pricing")} className="text-brand-inkSoft hover:text-brand-ink transition-colors" data-testid="footer-link-pricing">Prezzi</button></li>
              <li><a href="/dashboard" className="text-brand-inkSoft hover:text-brand-ink transition-colors" data-testid="footer-link-dashboard">Dashboard</a></li>
              <li><a href="/privacy" className="text-brand-inkSoft hover:text-brand-ink transition-colors" data-testid="footer-link-privacy">Privacy</a></li>
              <li><a href="/termini" className="text-brand-inkSoft hover:text-brand-ink transition-colors" data-testid="footer-link-terms">Termini</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm uppercase tracking-wider text-brand-ink mb-4">Contatti</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:robs@24vox.it" className="text-brand-inkSoft hover:text-brand-ink transition-colors" data-testid="footer-email">robs@24vox.it</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-brand-line flex flex-col md:flex-row justify-between gap-4 text-xs text-brand-inkSoft">
          <p data-testid="footer-copyright">© {year} 24Vox — Tutti i diritti riservati</p>
          <p data-testid="footer-vat">Omega AI Labs Ltd · Reg. 16998438 · 20 Wenlock Road, London N1 7GU</p>
        </div>
      </div>
    </footer>
  );
}
